import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 合约跟单系统-V1
enum API {
  // 合约跟单系统---跟单合约信息
  V1PerpetualFollowsCopyTradeContract = '/swap/v1/perpetual/follows/copyTradeContract',
  // 合约跟单系统--修改跟单设置、修改止赢止损
  V1PerpetualFollowsCopyTradeSetting = '/swap/v1/perpetual/follows/copyTradeSetting',
  // 合约跟单系统--当前跟单汇总
  V1PerpetualFollowsCurrentCopyTradeCollect = '/swap/v1/perpetual/follows/currentCopyTrade/collect',
  // 合约跟单系统--当前跟单仓位详情
  V1PerpetualFollowsCurrentCopyTradeDetail = '/swap/v1/perpetual/follows/currentCopyTrade/detail',
  // 合约跟单系统--历史跟单交易员
  V1PerpetualFollowsHistoryCopyTradeTrader = '/swap/v1/perpetual/follows/history/copyTradeTrader',
  // 合约跟单系统--历史跟单历史委托
  V1PerpetualFollowsHistoryHistoryTrade = '/swap/v1/perpetual/follows/history/historyTrade',
  // 合约跟单系统--历史跟单订单数据
  V1PerpetualFollowsHistoryHistoryTradeData = '/swap/v1/perpetual/follows/history/historyTradeData',
  // 合约跟单系统---是否是交易员
  V1PerpetualFollowsIsTrader = '/swap/v1/perpetual/follows/isTrader',
  // 合约跟单系统--交易员带单汇总
  V1PerpetualFollowsPublicTraderCollect = '/swap/v1/perpetual/follows/public/trader/collect',
  // 合约跟单系统--我的带单数据--当前跟单
  V1PerpetualFollowsMyLeadCopyTraderCurrent = '/swap/v1/perpetual/follows/myLead/copyTrader/current',
  // 合约跟单系统--我的带单数据--历史跟单
  V1PerpetualFollowsMyLeadCopyTraderHistory = '/swap/v1/perpetual/follows/myLead/copyTrader/history',
  // 合约跟单系统--我的带单数据--移除当前跟单用户
  V1PerpetualFollowsMyLeadCopyTraderRemove = '/swap/v1/perpetual/follows/myLead/copyTrader/remove',
  // 合约跟单系统--我的带单数据--当前带单
  V1PerpetualFollowsMyLeadDataCurrentTrade = '/swap/v1/perpetual/follows/myLead/data/currentTrade',
  // 合约跟单系统--我的带单数据--历史带单
  V1PerpetualFollowsMyLeadDataHistoryTradeDetail = '/swap/v1/perpetual/follows/myLead/data/historyTradeDetail',
  // 合约跟单系统--暂停带单
  V1PerpetualFollowsMyLeadPause = '/swap/v1/perpetual/follows/myLead/pause',
  // 合约跟单系统--恢复带单
  V1PerpetualFollowsMyLeadResume = '/swap/v1/perpetual/follows/myLead/resume',
  // 合约跟单系统--我的交易员
  V1PerpetualFollowsMyTraderList = '/swap/v1/perpetual/follows/myTraderList',
  // 合约跟单系统--开始跟单（跟单设置）
  V1PerpetualFollowsStartCopyTrade = '/swap/v1/perpetual/follows/startCopyTrade',
  // 合约跟单系统--结束跟单
  V1PerpetualFollowsStopCopyTrade = '/swap/v1/perpetual/follows/stopCopyTrade',
  // 合约跟单系统--交易员详情
  V1PerpetualFollowsTraderDetail = '/swap/v1/perpetual/follows/trader/detail',
  // 合约跟单系统--交易员列表
  V1PerpetualFollowsPublicTraderList = '/swap/v1/perpetual/follows/public/traderList',
  // 合约跟单系统--转入
  V1PerpetualFollowsTransferIn = '/swap/v1/perpetual/follows/transferIn',
  // 合约跟单系统--交易员当前带单
  V1PerpetualFollowsPublicTraderCurrentLead = '/swap/v1/perpetual/follows/public/trader/currentLead',
  // 合约跟单系统--交易员历史带单
  V1PerpetualFollowsPublicTraderHistoryLead = '/swap/v1/perpetual/follows/public/trader/historyLead',
  // 合约跟单系统--交易员统计跟单用户
  V1PerpetualFollowsPublicTraderStatisticsCopyTrader = '/swap/v1/perpetual/follows/public/trader/statistics/copyTrader',
  // 合约跟单系统---申请带单
  V1PerpetualFollowsApplyForTrader = '/swap/v1/perpetual/follows/applyForTrader',
  // 合约跟单系统--交易员统计
  V1PerpetualFollowsPublicTraderStatistics = '/swap/v1/perpetual/follows/public/trader/statistics',
  // 合约跟单系统---带单员设置
  V1PerpetualFollowsTraderSetting = '/swap/v1/perpetual/follows/traderSetting',
  // 合约跟单系统---用户是否符合交易员资质
  V1PerpetualFollowsTraderQualification = '/swap/v1/perpetual/follows/traderQualification',
  // 合约跟单系统---历史跟单统计
  V1PerpetualFollowsCopyTradeStatistics = '/swap/v1/perpetual/follows/copy-trade/statistics',
  // 合约跟单系统---带单员合约信息
  V1PerpetualFollowsPublicTraderContract = '/swap/v1/perpetual/follows/public/trader/contract',
  // 合约跟单系统---带单员设置
  V1PerpetualFollowsPublicTraderSetting = '/swap/v1/perpetual/follows/public/trader/setting',
  // 合约跟单系统--转出
  V1PerpetualFollowsTransferOut = '/swap/v1/perpetual/follows/transfer-out',
  // 合约跟单系统--交易员总统计
  V1PerpetualFollowsPublicTraderStatisticsMap = '/swap/v1/perpetual/follows/public/trader/statisticsMap',
  // 合约跟单系统---带单员设置V2
  V1PerpetualFollowsTraderSettingV2 = '/swap/v1/perpetual/follows/traderSettingV2',
  // 开启私域带单或者更新私域带单邀请码
  V1PerpetualFollowsOpenPrivateLead = '/swap/v1/perpetual/follows/open_private_lead',
  // 合约跟单系统--跟单验证
  V1PerpetualFollowsCheck = '/swap/v1/perpetual/follows/check',
}

export type TGetV1PerpetualFollowsCopyTradeContractParams = any
export type TGetV1PerpetualFollowsCopyTradeContractResponse = TResponse<
  {
    base?: string // 基础币
    baseDisplayName?: string // 基础货币前端显示名
    biz?: string // 业务类型:默认永续合约-perpetual
    contractCode?: string // 跟单合约
    contractCodeDisplayName?: string // 跟单合约前端显示名
    direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
    indexBase?: string // 指数价币
    indexBaseDisplayName?: string // 指数货币前端显示名
    isSelected?: boolean // 是否选中:true 选中，false 未选中
    quote?: string // 记价币
    quoteDisplayName?: string // 计价货币前端显示名
  }[]
>
export const getV1PerpetualFollowsCopyTradeContract = (params?: TGetV1PerpetualFollowsCopyTradeContractParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsCopyTradeContractResponse>(API.V1PerpetualFollowsCopyTradeContract, {
    params,
  })
}

export type TPutV1PerpetualFollowsCopyTradeSettingParams = {
  copyTraderId?: number // 跟单用户Id(不是uid)
  stopLossRatio?: number // 止损比例
  stopLossStopCopy?: number // 止损结束跟单：1-开启/0-关闭
  stopProfitRatio?: number // 止盈比例
  stopProfitStopCopy?: number // 止盈结束跟单：1-开启/0-关闭
  maxOrderCopyAmount?: number // 单个仓位最大保证金
  copyTradeContract?: string[] // 跟单合约:只能新增，只需要传新增的合约即可
  copyModel?: number // 跟单方式：1-固定金额/2-固定比例/3-同资金比例/4-固定张数
  orderCopyAmount?: number // 单笔跟单金额(单笔跟单张数
  copyRatio?: number // 跟单比例
  lever?: number // 杠杆倍数
  leverModel?: number // 1-低杠杆模式/2-跟随交易员/3-自定义
  autoAddMargin?: number // 自动追加保证金1-开启/0-关
}
export type TPutV1PerpetualFollowsCopyTradeSettingResponse = TResponse<boolean>
export const putV1PerpetualFollowsCopyTradeSetting = (params?: TPutV1PerpetualFollowsCopyTradeSettingParams) => {
  return hcAxios.put<TPutV1PerpetualFollowsCopyTradeSettingResponse>(API.V1PerpetualFollowsCopyTradeSetting, params)
}

export type TGetV1PerpetualFollowsCurrentCopyTradeCollectParams = any
export type TGetV1PerpetualFollowsCurrentCopyTradeCollectResponse = TResponse<{
  availableBalance?: string // 当前可用
  positionAccountRights?: string // 账户权益
  realizedSurplus?: string // 已实现盈亏
  totalTransferInBalance?: string // 跟单金额/带单金额
  unrealizedSurplus?: string // 未实现盈亏
}>
export const getV1PerpetualFollowsCurrentCopyTradeCollect = (
  params?: TGetV1PerpetualFollowsCurrentCopyTradeCollectParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsCurrentCopyTradeCollectResponse>(
    API.V1PerpetualFollowsCurrentCopyTradeCollect,
    { params }
  )
}

export type TGetV1PerpetualFollowsCurrentCopyTradeDetailParams = {
  leaderUserId?: any // leaderUserId
  selectedMode?: any // 固定写2
}
export type TGetV1PerpetualFollowsCurrentCopyTradeDetailResponse = TResponse<
  {
    availableBalance?: string // 当前可用
    copyTradeTime?: number // 开始跟单时间
    copyTraderId?: number // 跟单员Id
    copyTraderSetting?: {
      copyModel?: number // 跟单方式：1-固定金额/2-固定比例
      copyRatio?: string // 跟单比例
      lever?: number // 杠杆倍数
      leverModel?: number // 1-低杠杆模式/2-跟随交易员
      orderCopyAmount?: string // 单笔跟单金额
      startEvent?: number // 开始跟单触发事件：1-下一次开仓/2-带单员无仓位
      stopLossRatio?: string // 止损比例
      stopLossStopCopy?: number // 止损结束跟单：1-开启/0-关闭
      stopProfitRatio?: string // 止盈比例
      stopProfitStopCopy?: number // 止盈结束跟单：1-开启/0-关闭
    }
    copyTraderUid?: number // 跟单员UID
    currentPositions?: any[] // 当前持仓详情
    isNftPhoto?: boolean // 是否为NFT头像
    photo?: string // 带单员头像
    positionAccountRights?: string // 账户权益
    realizedSurplus?: string // 已实现盈亏
    totalTransferInBalance?: string // 跟单金额/带单金额
    traderId?: number // 带单员ID
    traderNickname?: number // 带单员昵称
    traderUid?: number // 带单员UId
    unrealizedSurplus?: string // 未实现盈亏
    traderLevel?: string // 交易员等级
  }[]
>
export const getV1PerpetualFollowsCurrentCopyTradeDetail = (
  params?: TGetV1PerpetualFollowsCurrentCopyTradeDetailParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsCurrentCopyTradeDetailResponse>(
    API.V1PerpetualFollowsCurrentCopyTradeDetail,
    { params }
  )
}

export type TGetV1PerpetualFollowsHistoryCopyTradeTraderParams = {
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
  traderNickname?: any // 昵称
  status?: any // 2-手动结束/3-止盈结束/4-止损结束/5-带单员移除/6-带单员结束/7-系统结束
}
export type TGetV1PerpetualFollowsHistoryCopyTradeTraderResponse = TResponse<{
  data?: {
    copyAmount?: string // 跟单总额
    copyTraderId?: number // 跟单员Id
    copyTraderUid?: number // 跟单员Uid
    createdDate?: number // 开始跟单时间
    isNftPhoto?: boolean // 是否为NFT头像
    modifyDate?: number // 结束跟单时间
    netProfit?: string // 跟单净利润
    photo?: string // 头像
    shareProfit?: string // 分润金额
    status?: number // 跟单状态：1-默认跟单中/2-手动结束/3-止盈结束/4-止损结束/5-带单员移除/6-带单员结束/7-系统结束
    traderId?: number // 交易员Id
    traderNickname?: number // 交易员昵称
    traderUid?: number // 交易员Uid
    traderLevel?: string // 交易员级别：1-初级/2-中级/3-高级
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsHistoryCopyTradeTrader = (
  params?: TGetV1PerpetualFollowsHistoryCopyTradeTraderParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsHistoryCopyTradeTraderResponse>(
    API.V1PerpetualFollowsHistoryCopyTradeTrader,
    { params }
  )
}

export type TGetV1PerpetualFollowsHistoryHistoryTradeParams = {
  contractCode?: any // 合约Code
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
  traderNickname?: any // 昵称
}
export type TGetV1PerpetualFollowsHistoryHistoryTradeResponse = TResponse<{
  data?: any[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsHistoryHistoryTrade = (params?: TGetV1PerpetualFollowsHistoryHistoryTradeParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsHistoryHistoryTradeResponse>(API.V1PerpetualFollowsHistoryHistoryTrade, {
    params,
  })
}

export type TGetV1PerpetualFollowsHistoryHistoryTradeDataParams = {
  contractCode?: any // 合约Code
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
  traderNickname?: any // 昵称
}
export type TGetV1PerpetualFollowsHistoryHistoryTradeDataResponse = TResponse<{
  data?: {
    closePrice?: string // 平仓均价
    closeTime?: number // 全部平完时间
    contractCode?: string // 合约Code
    contractCodeDisplayName?: string // 合约Code前端显示名
    id?: number // Id
    isNftPhoto?: boolean // 是否为NFT头像
    lever?: number // 杠杆
    openPrice?: string // 开仓均价
    openTime?: number // 开仓时间
    photo?: string // 头像
    positionType?: number // 0-全仓/1-逐仓
    profit?: string // 收益
    profitRate?: string // 收益率
    side?: string // 仓位方向，long多，short空
    traderNickname?: string // 带单员昵称
    traderUid?: number // 带单员uid
    amount?: number // 开仓张数
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsHistoryHistoryTradeData = (
  params?: TGetV1PerpetualFollowsHistoryHistoryTradeDataParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsHistoryHistoryTradeDataResponse>(
    API.V1PerpetualFollowsHistoryHistoryTradeData,
    { params }
  )
}

export type TGetV1PerpetualFollowsIsTraderParams = any
export type TGetV1PerpetualFollowsIsTraderResponse = TResponse<boolean>
export const getV1PerpetualFollowsIsTrader = (params?: TGetV1PerpetualFollowsIsTraderParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsIsTraderResponse>(API.V1PerpetualFollowsIsTrader, { params })
}

export type TGetV1PerpetualFollowsPublicTraderCollectParams = {
  traderUid?: any // 带单员Uid
}
export type TGetV1PerpetualFollowsPublicTraderCollectResponse = TResponse<{
  auditTime?: number // 审核时间
  followed?: boolean // 是否已经关注
  traderLevel?: number // 交易员级别：1-初级/2-中级/3-高级
  isOpenVacancyReminder?: boolean // 是否开启了空位提醒
  introduction?: string // 简介
  aum?: string // AUM 当前资产管理规模，所有当前跟单员的跟单金额总额
  aumCny?: string // 带单规模CNY，AUM 当前资产管理规模，所有当前跟单员的跟单金额总额
  availableBalance?: string // 合约账户可用
  copyTradeStatus?: number // 跟单状态：1-未跟随/2-跟随中
  copyTradeTime?: number // 开始跟随时间
  copyTrades?: number // 当前跟单人数
  createdDate?: number // 开始带单时间
  id?: number // 带单员ID
  isNftPhoto?: boolean // 是否为NFT头像
  leadDataScreening?: {
    copyTraders?: number // 累计跟单人数
    lossNums?: number // 亏损笔数
    profit?: string // 总收益（USDT)
    profitCny?: string // 总收益（CNY）
    profitNums?: number // 盈利笔数
    profitRate?: string // 收益率  比如为80% 返回80
    trades?: number // 交易笔数
  }
  maxCopyTraders?: number // 最大跟单人数
  nickName?: string // 昵称
  photo?: string // 头像
  profit?: string // 收益额（USDT）
  profitCny?: string // 收益额（CNY）
  profitRate?: string // 收益率  比如为80% 返回80
  winRate?: string // 胜率
  shareProfitRate?: string // 分润比例 比如为80% 返回80
  tradeStatus?: number // 带单状态：1-带单中/2-暂停带单/3-取消带单
  tradeStyle?: number[] // 风格标签 1-长线/2-短线/3-高频/4-低频/5-激进/6-保守
  traderContracts?: {
    base?: string // 基础币
    baseDisplayName?: string // 基础货币前端显示名
    biz?: string // 业务类型:默认永续合约-perpetual
    contractCode?: string // 跟单合约
    contractCodeDisplayName?: string // 跟单合约前端显示名
    direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
    indexBase?: string // 指数价币
    indexBaseDisplayName?: string // 指数货币前端显示名
    isSelected?: boolean // 是否选中:true 选中，false 未选中
    quote?: string // 记价币
    quoteDisplayName?: string // 计价货币前端显示名
  }[] // 带单合约
  traderStatus?: number // 带单员状态：1-待审核/2-被驳回/3-被取消资格/4-审核通过/5-完成带单初始化
  userId?: number // UID
  showHomeDataSetting?: number[] // 主页展示数据设置：1-当前跟随/2-入驻天数/3-总收益率/4-展示总收益/5-累计跟随/6-交易笔数/7-盈利笔数/8-亏损笔数/9-总胜率/10-资金实力/11-带单规模/12-带单数据
  showIndexDataSetting?: number[] // 首页展示数据设置:1-收益率/2-胜率/3-累计跟随/4-展示总收益/5-展示交易笔数/6-展示资金实力/7-展示带单规模/8-入驻天数
  lastFullTime?: number // 最近一次满员时间
  showTradeData?: boolean // 是否展示带单数据
  profitRateCharts?: {
    base?: string // 基础币
    contractCode?: string // 合约Code
    date?: string // 日期
    profit?: string // 收益
    profitRete?: string // 收益率
    tradeRatio?: string // 交易占比
    tradeSize?: string // 交易额
  }[] // 收益率走势图
  minCopyAmount?: string // 带单员设置的最小跟单金额
  privateDomainStatus?: number // 私域带单开启状态（0-关闭/1-开启）
  privateDomainInviteCode?: string // 私域带单邀请码（只有当前访问用户和带单员是同一个人是才展示私域邀请码）
}>
export const getV1PerpetualFollowsPublicTraderCollect = (params?: TGetV1PerpetualFollowsPublicTraderCollectParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderCollectResponse>(API.V1PerpetualFollowsPublicTraderCollect, {
    params,
  })
}

export type TGetV1PerpetualFollowsMyLeadCopyTraderCurrentParams = {
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
}
export type TGetV1PerpetualFollowsMyLeadCopyTraderCurrentResponse = TResponse<{
  data?: {
    availableAmount?: string // 当前可用
    copyAmount?: string // 跟单金额
    copyTradeStatus?: number // 跟单状态:1-有持仓/2-未交易/3-无持仓
    copyTraderId?: number // 跟单员id
    copyTraderNickname?: string // 跟单员昵称
    copyTraderUid?: number // 跟单员UID
    createdDate?: number // 开始跟单时间
    id?: number // ID
    isNftPhoto?: boolean // 是否为NFT头像
    photo?: string // 跟单员头像
    profit?: string // 跟单收益
    realizedSurplus?: string // 跟单已实现盈亏
    shareProfitAmount?: string // 已分润金额
    traderUid?: number // 带单员uid
    unrealizedSurplus?: string // 跟单未实现盈亏
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsMyLeadCopyTraderCurrent = (
  params?: TGetV1PerpetualFollowsMyLeadCopyTraderCurrentParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsMyLeadCopyTraderCurrentResponse>(
    API.V1PerpetualFollowsMyLeadCopyTraderCurrent,
    { params }
  )
}

export type TGetV1PerpetualFollowsMyLeadCopyTraderHistoryParams = {
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
}
export type TGetV1PerpetualFollowsMyLeadCopyTraderHistoryResponse = TResponse<{
  data?: {
    closeType?: number // 结束类型：1-默认跟单中/2-手动结束/3-止盈结束/4-止损结束/5-带单员移除/6-带单员结束/7-系统结束
    copyShareProfitAmount?: string // 跟单分润金额
    copyTradeAmount?: string // 跟单总金额
    copyTradeProfit?: string // 跟单净利润
    copyTraderId?: number // 跟单员id
    copyTraderNickname?: string // 跟单员昵称
    copyTraderUid?: number // 跟单员UID
    createdDate?: number // 开始跟单时间
    id?: number // ID
    isNftPhoto?: boolean // 是否为NFT头像
    photo?: string // 跟单员头像
    stopDate?: number // 结束跟单时间
    traderUid?: number // 带单员uid
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsMyLeadCopyTraderHistory = (
  params?: TGetV1PerpetualFollowsMyLeadCopyTraderHistoryParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsMyLeadCopyTraderHistoryResponse>(
    API.V1PerpetualFollowsMyLeadCopyTraderHistory,
    { params }
  )
}

export type TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveParams = {
  copyTraderId?: any // 跟单用户Id
}
export type TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveResponse = TResponse<boolean>
export const deleteV1PerpetualFollowsMyLeadCopyTraderRemove = (
  params?: TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveParams
) => {
  return hcAxios.delete<TDeleteV1PerpetualFollowsMyLeadCopyTraderRemoveResponse>(
    API.V1PerpetualFollowsMyLeadCopyTraderRemove,
    { params }
  )
}

export type TGetV1PerpetualFollowsMyLeadDataCurrentTradeParams = any
export type TGetV1PerpetualFollowsMyLeadDataCurrentTradeResponse = TResponse<{
  availableBalance?: string // 当前可用
  currentPositions?: any[] // 持仓列表
  positionAccountRights?: string // 账户权益
  realizedSurplus?: string // 已实现盈亏
  totalTransferInBalance?: string // 跟单金额/带单金额
  unrealizedSurplus?: string // 未实现盈亏
}>
export const getV1PerpetualFollowsMyLeadDataCurrentTrade = (
  params?: TGetV1PerpetualFollowsMyLeadDataCurrentTradeParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsMyLeadDataCurrentTradeResponse>(
    API.V1PerpetualFollowsMyLeadDataCurrentTrade,
    { params }
  )
}

export type TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailParams = {
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
}
export type TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailResponse = TResponse<{
  data?: {
    closePrice?: string // 平仓均价
    closeTime?: number // 全部平完时间
    contractCode?: string // 合约Code
    copyProfit?: string // 跟单者盈亏
    copyTraders?: number // 跟单人数
    id?: number // 带单员Id
    isNftPhoto?: boolean // 是否为NFT头像
    lever?: number // 杠杆
    openPrice?: string // 开仓均价
    openTime?: number // 开仓时间
    photo?: string // 头像
    positionType?: number // 0-全仓/1-逐仓
    profit?: string // 收益
    profitRate?: string // 收益率
    side?: string // 仓位方向，long多，short空
    tradeContract?: {
      base?: string // 基础币
      baseDisplayName?: string // 基础货币前端显示名
      biz?: string // 业务类型:默认永续合约-perpetual
      contractCode?: string // 跟单合约
      contractCodeDisplayName?: string // 跟单合约前端显示名
      direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
      indexBase?: string // 指数价币
      indexBaseDisplayName?: string // 指数货币前端显示名
      isSelected?: boolean // 是否选中:true 选中，false 未选中
      quote?: string // 记价币
      quoteDisplayName?: string // 计价货币前端显示名
    }
    traderNickname?: string // 带单员昵称
    traderUid?: number // 带单员uid
    selectedMode?: number // 持仓模式
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsMyLeadDataHistoryTradeDetail = (
  params?: TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsMyLeadDataHistoryTradeDetailResponse>(
    API.V1PerpetualFollowsMyLeadDataHistoryTradeDetail,
    { params }
  )
}

export type TGetV1PerpetualFollowsMyLeadPauseParams = any
export type TGetV1PerpetualFollowsMyLeadPauseResponse = TResponse<boolean>
export const getV1PerpetualFollowsMyLeadPause = (params?: TGetV1PerpetualFollowsMyLeadPauseParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsMyLeadPauseResponse>(API.V1PerpetualFollowsMyLeadPause, { params })
}

export type TGetV1PerpetualFollowsMyLeadResumeParams = any
export type TGetV1PerpetualFollowsMyLeadResumeResponse = TResponse<boolean>
export const getV1PerpetualFollowsMyLeadResume = (params?: TGetV1PerpetualFollowsMyLeadResumeParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsMyLeadResumeResponse>(API.V1PerpetualFollowsMyLeadResume, { params })
}

export type TGetV1PerpetualFollowsMyTraderListParams = {
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
  traderNickname?: any // 昵称
  traderUid?: any // 带单者Uid
}
export type TGetV1PerpetualFollowsMyTraderListResponse = TResponse<{
  data?: {
    auditTime?: number // 审核时间
    followed?: boolean // 是否已经关注
    aum?: string // AUM 当前资产管理规模，所有当前跟单员的跟单金额总额
    availableBalance?: string // 合约账户可用
    copyTradeStatus?: number // 跟单状态：1-未跟随/2-跟随中
    copyTradeTime?: number // 开始跟随时间
    copyTrades?: number // 当前跟单人数
    createdDate?: number // 开始带单时间
    id?: number // 带单员ID
    isNftPhoto?: boolean // 是否为NFT头像
    leadDataScreening?: {
      copyTraders?: number // 累计跟单人数
      lossNums?: number // 亏损笔数
      profit?: string // 总收益（USDT)
      profitNums?: number // 盈利笔数
      profitRate?: string // 收益率  比如为80% 返回80
      trades?: number // 交易笔数
    }
    maxCopyTraders?: number // 最大跟单人数
    nickName?: string // 昵称
    photo?: string // 头像
    profit?: string // 收益额（USDT）
    profitRate?: string // 收益率  比如为80% 返回80
    shareProfitRate?: string // 分润比例 比如为80% 返回80
    tradeStatus?: number // 带单状态：1-带单中/2-暂停带单/3-取消带单
    tradeStyle?: number[] // 风格标签 1-长线/2-短线/3-高频/4-低频/5-激进/6-保守
    traderContracts?: {
      base?: string // 基础币
      baseDisplayName?: string // 基础货币前端显示名
      biz?: string // 业务类型:默认永续合约-perpetual
      contractCode?: string // 跟单合约
      contractCodeDisplayName?: string // 跟单合约前端显示名
      direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
      indexBase?: string // 指数价币
      indexBaseDisplayName?: string // 指数货币前端显示名
      isSelected?: boolean // 是否选中:true 选中，false 未选中
      quote?: string // 记价币
      quoteDisplayName?: string // 计价货币前端显示名
    }[] // 带单合约
    traderStatus?: number // 带单员状态：1-待审核/2-被驳回/3-被取消资格/4-审核通过/5-完成带单初始化
    userId?: number // UID
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsMyTraderList = (params?: TGetV1PerpetualFollowsMyTraderListParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsMyTraderListResponse>(API.V1PerpetualFollowsMyTraderList, { params })
}

export type TPostV1PerpetualFollowsStartCopyTradeParams = {
  orderCopyAmount?: number // 单笔跟单金额(单笔跟单张数)
  copyModel?: number // 跟单方式：1-固定金额/2-固定比例/3-同资金比例/4-固定张数
  copyRatio?: number // 跟单比例
  copyTradeContracts?: string[] // 跟单合约
  lever?: number // 杠杆倍数
  leverModel?: number // 1-低杠杆模式/2-跟随交易员/3-自定义杠杆倍数
  startEvent?: number // 开始跟单触发事件：1-下一次开仓/2-带单员无仓位
  stopLossRatio?: number // 止损比例
  stopLossStopCopy?: number // 止损结束跟单：1-开启/0-关闭
  stopProfitRatio?: number // 止盈比例
  stopProfitStopCopy?: number // 止盈结束跟单：1-开启/0-关闭
  traderId?: number // 带单员ID
  transferInAmount?: number // 跟单金额-从合约账户初次转入的金额
  autoAddMargin?: number // 自动追加保证金1-开启/2-关闭
  maxOrderCopyAmount?: number // 单个仓位最大保证金
  privateDomainInviteCode?: string // 带单邀请码
  channel?: number // 0-交易/1-直播
}
export type TPostV1PerpetualFollowsStartCopyTradeResponse = TResponse<boolean>
export const postV1PerpetualFollowsStartCopyTrade = (params?: TPostV1PerpetualFollowsStartCopyTradeParams) => {
  return hcAxios.post<TPostV1PerpetualFollowsStartCopyTradeResponse>(API.V1PerpetualFollowsStartCopyTrade, params)
}

export type TPutV1PerpetualFollowsStopCopyTradeParams = {}
export type TPutV1PerpetualFollowsStopCopyTradeResponse = TResponse<boolean>
export const putV1PerpetualFollowsStopCopyTrade = (params?: TPutV1PerpetualFollowsStopCopyTradeParams) => {
  return hcAxios.put<TPutV1PerpetualFollowsStopCopyTradeResponse>(API.V1PerpetualFollowsStopCopyTrade, params)
}

export type TGetV1PerpetualFollowsTraderDetailParams = {
  traderUid?: any // 带单者Uid
}
export type TGetV1PerpetualFollowsTraderDetailResponse = TResponse<{
  aum?: string // AUM 当前资产管理规模，所有当前跟单员的跟单金额总额
  availableBalance?: string // 合约账户可用
  copyTradeTime?: number // 开始跟随时间
  copyTrades?: number // 当前跟单人数
  createdDate?: number // 开始带单时间
  id?: number // 带单员ID
  leadDataScreening?: {
    copyTraders?: number // 累计跟单人数
    lossNums?: number // 亏损笔数
    profit?: string // 总收益（USDT)
    profitNums?: number // 盈利笔数
    profitRate?: string // 收益率
    trades?: number // 交易笔数
  }
  maxCopyTraders?: number // 最大跟单人数
  nickName?: string // 昵称
  profit?: string // 收益额（USDT）
  profitRate?: string // 收益率
  shareProfitRate?: string // 分润比例
  tradeStatus?: string // 带单状态：1-带单中/2-暂停带单/3-取消带单
  tradeStyle?: number[] // 风格标签 1-长线/2-短线/3-高频/4-低频/5-激进/6-保守
  traderContracts?: {
    base?: string // 基础币
    baseDisplayName?: string // 基础货币前端显示名
    biz?: string // 业务类型:默认永续合约-perpetual
    contractCode?: string // 跟单合约
    contractCodeDisplayName?: string // 跟单合约前端显示名
    direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
    env?: number // 0-实盘/1-模拟盘
    indexBase?: string // 指数价币
    indexBaseDisplayName?: string // 指数货币前端显示名
    quote?: string // 记价币
    quoteDisplayName?: string // 计价货币前端显示名
  }[] // 带单合约
  userId?: number // UID
}>
export const getV1PerpetualFollowsTraderDetail = (params?: TGetV1PerpetualFollowsTraderDetailParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsTraderDetailResponse>(API.V1PerpetualFollowsTraderDetail, { params })
}

export type TGetV1PerpetualFollowsPublicTraderListParams = {
  hideFull?: any // 隐藏满员：true/false
  pageNum?: any // 第几页
  pageSize?: any // 页面大小
  sortField?: any // 排序字段：收益率-profitRate/总收益-profit/累计跟单人数-copyTrades/资金实力-availableBalance/胜率-winRate
  sortType?: any // 排序类型：升序-asc/降序-desc
  tradeStatus?: any // 带单状态：1-带单中/2-暂停带单
  traderNickname?: any // 昵称
  traderUid?: any // 带单者Uid
  contractCodes?: any // 合约codes
  traderLevels?: any // 交易员级别：1-初级/2-中级/3-高级
  onlyWatched?: any // 是否只返回关注列表
  privateDomainStatus?: any // 私域带单开启状态（0-关闭/1-开启）
}
export type TGetV1PerpetualFollowsPublicTraderListResponse = TResponse<{
  data?: {
    auditTime?: number // 审核时间
    traderLevel?: number // 交易员级别：1-初级/2-中级/3-高级
    followed?: boolean // 是否已经关注
    isOpenVacancyReminder?: boolean // 是否开启了空位提醒
    introduction?: string // 简介
    aum?: string // AUM 当前资产管理规模，所有当前跟单员的跟单金额总额
    aumCny?: string // 带单规模CNY，AUM 当前资产管理规模，所有当前跟单员的跟单金额总额
    availableBalance?: string // 合约账户可用
    copyTradeStatus?: number // 跟单状态：1-未跟随/2-跟随中
    copyTradeTime?: number // 开始跟随时间
    copyTrades?: number // 当前跟单人数
    createdDate?: number // 开始带单时间
    id?: number // 带单员ID
    isNftPhoto?: boolean // 是否为NFT头像
    leadDataScreening?: {
      copyTraders?: number // 累计跟单人数
      lossNums?: number // 亏损笔数
      profit?: string // 总收益（USDT)
      profitCny?: string // 总收益（CNY）
      profitNums?: number // 盈利笔数
      profitRate?: string // 收益率  比如为80% 返回80
      trades?: number // 交易笔数
    }
    maxCopyTraders?: number // 最大跟单人数
    nickName?: string // 昵称
    photo?: string // 头像
    profit?: string // 收益额（USDT）
    profitCny?: string // 收益额（CNY）
    profitRate?: string // 收益率  比如为80% 返回80
    winRate?: string // 胜率
    shareProfitRate?: string // 分润比例 比如为80% 返回80
    tradeStatus?: number // 带单状态：1-带单中/2-暂停带单/3-取消带单
    tradeStyle?: number[] // 风格标签 1-长线/2-短线/3-高频/4-低频/5-激进/6-保守
    traderContracts?: {
      base?: string // 基础币
      baseDisplayName?: string // 基础货币前端显示名
      biz?: string // 业务类型:默认永续合约-perpetual
      contractCode?: string // 跟单合约
      contractCodeDisplayName?: string // 跟单合约前端显示名
      direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
      indexBase?: string // 指数价币
      indexBaseDisplayName?: string // 指数货币前端显示名
      isSelected?: boolean // 是否选中:true 选中，false 未选中
      quote?: string // 记价币
      quoteDisplayName?: string // 计价货币前端显示名
    }[] // 带单合约
    traderStatus?: number // 带单员状态：1-待审核/2-被驳回/3-被取消资格/4-审核通过/5-完成带单初始化
    userId?: number // UID
    showHomeDataSetting?: number[] // 主页展示数据设置：1-当前跟随/2-入驻天数/3-总收益率/4-展示总收益/5-累计跟随/6-交易笔数/7-盈利笔数/8-亏损笔数/9-总胜率/10-资金实力/11-带单规模/12-带单数据
    showIndexDataSetting?: number[] // 首页展示数据设置:1-收益率/2-胜率/3-累计跟随/4-展示总收益/5-展示交易笔数/6-展示资金实力/7-展示带单规模/8-入驻天数
    lastFullTime?: number // 最近一次满员时间
    showTradeData?: boolean // 是否展示带单数据
    profitRateCharts?: {
      base?: string // 基础币
      contractCode?: string // 合约Code
      date?: string // 日期
      profit?: string // 收益
      profitRete?: string // 收益率
      tradeRatio?: string // 交易占比
      tradeSize?: string // 交易额
    }[] // 收益率走势图
    minCopyAmount?: string // 带单员设置的最小跟单金额
    appLogs?: string[] // 带单币logo
    privateDomainStatus?: string // 私域带单开启状态（0-关闭/1-开启）
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsPublicTraderList = (params?: TGetV1PerpetualFollowsPublicTraderListParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderListResponse>(API.V1PerpetualFollowsPublicTraderList, { params })
}

export type TPutV1PerpetualFollowsTransferInParams = {
  amount?: number // 转入数量
  copyTraderId?: number // 跟单账户ID
  currency?: string // 币种
}
export type TPutV1PerpetualFollowsTransferInResponse = TResponse<boolean>
export const putV1PerpetualFollowsTransferIn = (params?: TPutV1PerpetualFollowsTransferInParams) => {
  return hcAxios.put<TPutV1PerpetualFollowsTransferInResponse>(API.V1PerpetualFollowsTransferIn, params)
}

export type TGetV1PerpetualFollowsPublicTraderCurrentLeadParams = {
  traderUid?: any // 交易员Uid
}
export type TGetV1PerpetualFollowsPublicTraderCurrentLeadResponse = TResponse<any>
export const getV1PerpetualFollowsPublicTraderCurrentLead = (
  params?: TGetV1PerpetualFollowsPublicTraderCurrentLeadParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderCurrentLeadResponse>(
    API.V1PerpetualFollowsPublicTraderCurrentLead,
    { params }
  )
}

export type TGetV1PerpetualFollowsPublicTraderHistoryLeadParams = {
  pageNum?: any // 页面大小
  pageSiz?: any // 第几页
  traderUid?: any // 交易员Uid
}
export type TGetV1PerpetualFollowsPublicTraderHistoryLeadResponse = TResponse<{
  data?: {
    closePrice?: string // 平仓均价
    closeTime?: number // 全部平完时间
    contractCode?: string // 合约Code
    copyProfit?: string // 跟单者盈亏
    copyTraders?: number // 跟单人数
    id?: number // 带单员Id
    isNftPhoto?: boolean // 是否为NFT头像
    lever?: number // 杠杆
    openPrice?: string // 开仓均价
    openTime?: number // 开仓时间
    photo?: string // 头像
    positionType?: number // 0-全仓/1-逐仓
    profit?: string // 收益
    profitRate?: string // 收益率
    side?: string // 仓位方向，long多，short空
    tradeContract?: {
      base?: string // 基础币
      baseDisplayName?: string // 基础货币前端显示名
      biz?: string // 业务类型:默认永续合约-perpetual
      contractCode?: string // 跟单合约
      contractCodeDisplayName?: string // 跟单合约前端显示名
      direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
      indexBase?: string // 指数价币
      indexBaseDisplayName?: string // 指数货币前端显示名
      isSelected?: boolean // 是否选中:true 选中，false 未选中
      quote?: string // 记价币
      quoteDisplayName?: string // 计价货币前端显示名
    }
    traderNickname?: string // 带单员昵称
    traderUid?: number // 带单员uid
    selectedMode?: number // 持仓模式
  }[] // 数据体
  pageNum?: number // 第几页
  pageSize?: number // 页面大小
  totalCount?: number // 总条数
  totalPage?: number // 总页数
}>
export const getV1PerpetualFollowsPublicTraderHistoryLead = (
  params?: TGetV1PerpetualFollowsPublicTraderHistoryLeadParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderHistoryLeadResponse>(
    API.V1PerpetualFollowsPublicTraderHistoryLead,
    { params }
  )
}

export type TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderParams = {
  limit?: any // 前 limit 条数据
  traderUid?: any // 交易员Uid
}
export type TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderResponse = TResponse<
  {
    copyAmount?: string // 跟单金额
    copyTraderId?: number // 跟单用户ID
    copyTraderNickname?: string // 跟单用户昵称
    copyTraderUid?: number // 跟单用户UID
    isNftPhoto?: boolean // 是否为NFT头像
    photo?: string // 头像
    profit?: string // 跟单收益
  }[]
>
export const getV1PerpetualFollowsPublicTraderStatisticsCopyTrader = (
  params?: TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderStatisticsCopyTraderResponse>(
    API.V1PerpetualFollowsPublicTraderStatisticsCopyTrader,
    { params }
  )
}

export type TPostV1PerpetualFollowsApplyForTraderParams = any
export type TPostV1PerpetualFollowsApplyForTraderResponse = TResponse<boolean>
export const postV1PerpetualFollowsApplyForTrader = (params?: TPostV1PerpetualFollowsApplyForTraderParams) => {
  return hcAxios.post<TPostV1PerpetualFollowsApplyForTraderResponse>(API.V1PerpetualFollowsApplyForTrader, params)
}

export type TGetV1PerpetualFollowsPublicTraderStatisticsParams = any
export type TGetV1PerpetualFollowsPublicTraderStatisticsResponse = TResponse<
  {
    base?: string // 基础币
    contractCode?: string // 合约Code
    date?: string // 日期
    profit?: string // 收益
    profitRete?: string // 收益率
    tradeRatio?: string // 交易占比
    tradeSize?: string // 交易额
  }[]
>
export const getV1PerpetualFollowsPublicTraderStatistics = (
  params?: TGetV1PerpetualFollowsPublicTraderStatisticsParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderStatisticsResponse>(
    API.V1PerpetualFollowsPublicTraderStatistics,
    { params }
  )
}

export type TPutV1PerpetualFollowsTraderSettingParams = {
  tradeContracts?: string[] // 带单合约
  tradeStyles?: number[] // 风格标签 1-长线/2-短线/3-高频/4-低频/5-激进/6-保守
  minCopyAmount?: number // 最小跟单金额
  shareProfitRate?: number // 分润比例
  introduction?: string // 简介
  showIndexDataSetting?: number[] // 首页展示数据设置:1-收益率/2-胜率/3-累计跟随/4-展示总收益/5-展示交易笔数/6-展示资金实力/7-展示带单规模/8-入驻天数
  showHomeDataSetting?: number[] // 主页展示数据设置：1-当前跟随/2-入驻天数/3-总收益率/4-展示总收益/5-累计跟随/6-交易笔数/7-盈利笔数/8-亏损笔数/9-总胜率/10-资金实力/11-带单规模/12-带单数据
  showTradeData?: boolean // 是否展示带单数据
}
export type TPutV1PerpetualFollowsTraderSettingResponse = TResponse<boolean>
export const putV1PerpetualFollowsTraderSetting = (params?: TPutV1PerpetualFollowsTraderSettingParams) => {
  return hcAxios.put<TPutV1PerpetualFollowsTraderSettingResponse>(API.V1PerpetualFollowsTraderSetting, params)
}

export type TGetV1PerpetualFollowsTraderQualificationParams = any
export type TGetV1PerpetualFollowsTraderQualificationResponse = TResponse<{
  availableMeet?: boolean // 可用足够
  dualPosition?: boolean // 双向持仓
  haveCopyTrade?: boolean // 有跟单
  havePosition?: boolean // 有持仓或挂单
  minLeadAmount?: string // 最小带单金额
}>
export const getV1PerpetualFollowsTraderQualification = (params?: TGetV1PerpetualFollowsTraderQualificationParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsTraderQualificationResponse>(API.V1PerpetualFollowsTraderQualification, {
    params,
  })
}

export type TGetV1PerpetualFollowsCopyTradeStatisticsParams = any
export type TGetV1PerpetualFollowsCopyTradeStatisticsResponse = TResponse<
  {
    totalTransferIn?: string // 历史跟单总金额
    totalHistoryProfit?: string // 总收益
    totalHistoryOrderNums?: string // 历史跟单笔数
    totalHistoryShareProfit?: string // 跟单分润金额
    totalProfitWithUnRealizedSurplus?: string // 跟单净利润
    totalProfitableOrderNums?: number // 盈利笔数
    totalLossOrderNums?: number // 损失笔数
    totalFollowTraders?: number // 总跟单人数
  }[]
>
export const getV1PerpetualFollowsCopyTradeStatistics = (params?: TGetV1PerpetualFollowsCopyTradeStatisticsParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsCopyTradeStatisticsResponse>(API.V1PerpetualFollowsCopyTradeStatistics, {
    params,
  })
}

export type TGetV1PerpetualFollowsPublicTraderContractParams = {
  traderUid?: any // 不传值返回所有可带单合约，传值返回带单员所带单的合约
}
export type TGetV1PerpetualFollowsPublicTraderContractResponse = TResponse<
  {
    base?: string // 基础币
    baseDisplayName?: string // 基础货币前端显示名
    biz?: string // 业务类型:默认永续合约-perpetual
    contractCode?: string // 跟单合约
    contractCodeDisplayName?: string // 跟单合约前端显示名
    direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
    indexBase?: string // 指数价币
    indexBaseDisplayName?: string // 指数货币前端显示名
    isSelected?: boolean // 是否选中:true 选中，false 未选中
    quote?: string // 记价币
    quoteDisplayName?: string // 计价货币前端显示名
  }[]
>
export const getV1PerpetualFollowsPublicTraderContract = (
  params?: TGetV1PerpetualFollowsPublicTraderContractParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderContractResponse>(API.V1PerpetualFollowsPublicTraderContract, {
    params,
  })
}

export type TGetV1PerpetualFollowsPublicTraderSettingParams = {
  traderUid?: any // 不传值返回系统初始的带单信息，传值返回带单员设置的带单信息
}
export type TGetV1PerpetualFollowsPublicTraderSettingResponse = TResponse<{
  maxCopyAmount?: string // -1 表示不限制，最大跟单金额
  maxOrderCopyAmount?: string // 单笔订单固定最大跟单金额
  maxOrderCopyProportion?: string // 单笔跟单固定最大比例
  minCopyAmount?: string // 最小跟单金额
  minLeadAmount?: string // 最小带单金额
  minOrderCopyAmount?: string // 单笔订单固定最小跟单金额
  minOrderCopyProportion?: string // 单笔跟单固定最小比例
  shareProfitRate?: string // 最大可设置分润比例
  tradeContract?: {
    base?: string // 基础币
    baseDisplayName?: string // 基础货币前端显示名
    biz?: string // 业务类型:默认永续合约-perpetual
    contractCode?: string // 跟单合约
    contractCodeDisplayName?: string // 跟单合约前端显示名
    direction?: number // 合约类型：0-金本位合约（USDT合约）/1-币本位合约
    indexBase?: string // 指数价币
    indexBaseDisplayName?: string // 指数货币前端显示名
    isSelected?: boolean // 是否选中:true 选中，false 未选中
    quote?: string // 记价币
    quoteDisplayName?: string // 计价货币前端显示名
    maxLever?: number // 合约最大杠杆
    maxCopyLever?: number // 最大跟单杠杆
  }[] // 带单合约
  minOrderCopyNum?: number // 最小单笔跟单张数
  maxOrderCopyNum?: number // 最大单笔跟单张数
  minOrderMargin?: string // 最小跟随保证金
  maxOrderMargin?: string // 最大跟随保证金
  privateDomainStatus?: number // 私域带单开启状态（0-关闭/1-开启）
  privateDomainInviteCode?: string // 私域带单邀请码
  copyAmount?: string // 带单员设置最低跟单金额,为0 表示没有设置
}>
export const getV1PerpetualFollowsPublicTraderSetting = (params?: TGetV1PerpetualFollowsPublicTraderSettingParams) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderSettingResponse>(API.V1PerpetualFollowsPublicTraderSetting, {
    params,
  })
}

export type TPutV1PerpetualFollowsTransferOutParams = {
  amount?: number // 转入数量
  currency?: string // 币种
  copyTraderId?: number // 跟单账户ID
}
export type TPutV1PerpetualFollowsTransferOutResponse = TResponse<boolean>
export const putV1PerpetualFollowsTransferOut = (params?: TPutV1PerpetualFollowsTransferOutParams) => {
  return hcAxios.put<TPutV1PerpetualFollowsTransferOutResponse>(API.V1PerpetualFollowsTransferOut, params)
}

export type TGetV1PerpetualFollowsPublicTraderStatisticsMapParams = any
export type TGetV1PerpetualFollowsPublicTraderStatisticsMapResponse = TResponse<any[]>
export const getV1PerpetualFollowsPublicTraderStatisticsMap = (
  params?: TGetV1PerpetualFollowsPublicTraderStatisticsMapParams
) => {
  return hcAxios.get<TGetV1PerpetualFollowsPublicTraderStatisticsMapResponse>(
    API.V1PerpetualFollowsPublicTraderStatisticsMap,
    { params }
  )
}

export type TPutV1PerpetualFollowsTraderSettingV2Params = {
  tradeContracts?: string[] // 带单合约
  tradeStyles?: number[] // 风格标签 1-长线/2-短线/3-高频/4-低频/5-激进/6-保守
  minCopyAmount?: number // 最小跟单金额，关闭传0
  shareProfitRate?: number // 分润比例
  introduction?: string // 简介
  showIndexDataSetting?: number[] // 首页展示数据设置:1-收益率/2-胜率/3-累计跟随/4-展示总收益/5-展示交易笔数/6-展示资金实力/7-展示带单规模/8-入驻天数
  showHomeDataSetting?: number[] // 主页展示数据设置：1-当前跟随/2-入驻天数/3-总收益率/4-展示总收益/5-累计跟随/6-交易笔数/7-盈利笔数/8-亏损笔数/9-总胜率/10-资金实力/11-带单规模/12-带单数据
  showTradeData?: boolean // 是否展示带单数据
  openPrivateDomain?: boolean // 是否开启私域带单
}
export type TPutV1PerpetualFollowsTraderSettingV2Response = TResponse<string>
export const putV1PerpetualFollowsTraderSettingV2 = (params?: TPutV1PerpetualFollowsTraderSettingV2Params) => {
  return hcAxios.put<TPutV1PerpetualFollowsTraderSettingV2Response>(API.V1PerpetualFollowsTraderSettingV2, params)
}

export type TPostV1PerpetualFollowsOpenPrivateLeadParams = any
export type TPostV1PerpetualFollowsOpenPrivateLeadResponse = TResponse<string>
export const postV1PerpetualFollowsOpenPrivateLead = (params?: TPostV1PerpetualFollowsOpenPrivateLeadParams) => {
  return hcAxios.post<TPostV1PerpetualFollowsOpenPrivateLeadResponse>(API.V1PerpetualFollowsOpenPrivateLead, params)
}

export type TPutV1PerpetualFollowsCheckParams = {
  privateDomainInviteCode?: string // 私域带单邀请码
  traderId?: number // 带单id
}
export type TPutV1PerpetualFollowsCheckResponse = TResponse<boolean>
export const putV1PerpetualFollowsCheck = (params?: TPutV1PerpetualFollowsCheckParams) => {
  return hcAxios.put<TPutV1PerpetualFollowsCheckResponse>(API.V1PerpetualFollowsCheck, params)
}
